import { getCurrentUserId } from 'conversations/modules/user/selectors'
import { createSelector } from 'reselect'
import { Team, TeamEnabledSettings } from 'shared/typings/teams/Team'

import { RootState } from 'typesafe-actions'

const root = (state: RootState) => state.convo.teams

export const getTeamsById = (state: RootState) => root(state).byId

export const getTeamById = (teamId: number) => (state: RootState) => root(state).byId[teamId]

export const getTeams = createSelector(getTeamsById, (teams) => Object.values(teams))

export const getUserTeamIds = createSelector(getTeamsById, getCurrentUserId, (teams, userId) => {
  if (!userId) {
    return []
  } else {
    return Object.values(teams)
      .filter((team) => team.members.includes(userId))
      .map((team) => team.id)
  }
})

export const abilityEnabledFromAnyTeam = (ability: TeamEnabledSettings) =>
  createSelector(getTeams, getCurrentUserId, (teams: Team[], userId) => {
    if (!userId) {
      return false
    } else {
      return teams.some((team) => team.members.includes(userId) && team[ability])
    }
  })
